/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor, // @acavan!
    user = require('../models/user');

module.exports = Backbone.Model.extend({
    // @acavan! - do we need this empty model? could we just extend in place? or rather, is this event used? (20191122_1158)
});
